var _path;
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2,15.000015 H 22 V 17 H 2 Z M 2,7 H 22 V 8.9999849 H 2 Z"
  }));
};
export default SvgMenu;